import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { Skeleton } from 'apps/shared/scripts/components';

const LoadingCards = () => {
  return (
    <ContentCard>
      <Skeleton borderRadius={100} height={10} count={2} />
    </ContentCard>
  );
};

LoadingCards.displayName = 'LoadingCards';

export default LoadingCards;
